const appFormatLang = {
	kilo_prefix: {
		tag: 'app.format.kilo_prefix',
		fr: 'k',
		en: 'k',
	},
	million_prefix: {
		tag: 'app.format.million_prefix',
		fr: 'M',
		en: 'M',
	},
	billion_prefix: {
		tag: 'app.format.billion_prefix',
		fr: 'Md',
		en: 'b',
	},
};

export default appFormatLang;
